import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Env } from '@contexts/AppContext';

import LayOut from './LayOut';

const queryClient = new QueryClient();

const OrgSignUp = ({ isGdprRequired, env }: { isGdprRequired: boolean; env: Env }) => (
  <QueryClientProvider client={queryClient}>
    <LayOut gdpr={isGdprRequired} env={env} />;
  </QueryClientProvider>
);

export default OrgSignUp;
